import { format } from 'date-fns';
import * as React from 'react';

import {
  List,
  Datagrid,
  TextField,
  SearchInput,
  ImageField,
  BooleanField,
  NumberField,
  FunctionField,
} from 'react-admin';

const filters = [<SearchInput source='name' alwaysOn />];

export default function ResourceList(props: any) {
  return (
    <List {...props} filters={filters}>
      <Datagrid rowClick='edit'>
        <NumberField source='id' />
        <TextField source='name' />
        <TextField source='code' />
        <TextField source='discount' />
        <BooleanField source='isPercentage' />
        <FunctionField
          source='startDate'
          render={(record: any) =>
            `${format(new Date(record.startDate), 'dd/MM/yyyy')}`
          }
        />
        <FunctionField
          source='endDate'
          render={(record: any) =>
            `${format(new Date(record.endDate), 'dd/MM/yyyy')}`
          }
        />
        <TextField source='minShop' />
        <TextField source='maxShop' />
        <TextField source='participationsLimit' />
        <BooleanField source='isActive' />
      </Datagrid>
    </List>
  );
}
